export function token() {
  return localStorage.getItem('token');
}

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

export const getRequestOptions = (
  method: HttpMethod = 'GET',
  body?: Record<string, any> | null,
  contentType = 'application/json',
  signal?: AbortSignal
) => {
  const accessToken = token();
  const options = {
    method,
    headers: {
      'Content-Type': contentType,
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    body: body && JSON.stringify(body),
    signal,
  };

  return options;
};
